import { render, staticRenderFns } from "./forms.vue?vue&type=template&id=3d3f3b60"
import script from "./forms.vue?vue&type=script&lang=js"
export * from "./forms.vue?vue&type=script&lang=js"
import style0 from "./forms.vue?vue&type=style&index=0&id=3d3f3b60&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./forms.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports